import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

import { LOCALE } from 'interfaces/types'

import { LandingPageBanner } from './banner'

export const StyledLandingWrapper = styled.div`
  overflow: visible;

  min-height: 100vh;
  .banner {
    background-color: ${theme.colors.gray100};
  }

  #div-gpt-ad-home-top,
  #div-gpt-ad-home-sidebar1,
  #div-gpt-ad-home-sidebar2 {
    div {
      display: flex;
      overflow: hidden;
      max-width: 100%;
      justify-content: center;
    }
  }
  margin-bottom: 80px;

  .html-div {
    color: ${theme.colors.gray800};
    &[data-size='small'] {
      font-size: 16px;
      ${MediaQueries.mbUp} {
        font-size: 18px;
      }
    }
    &[data-size='medium'] {
      font-size: 19px;
      ${MediaQueries.mbUp} {
        font-size: 22px;
      }
    }
    &[data-size='large'] {
      font-size: 24px;
      ${MediaQueries.mbUp} {
        font-size: 27px;
      }
    }

    ${MediaQueries.mbUp} {
      margin: 32px 0px;
      font-size: 18px;
      font-weight: normal;
      letter-spacing: -0.2px;
      line-height: 32px;
    }

    ${MediaQueries.mbDown} {
      font-weight: normal;
      font-size: 16px;
      line-height: 28px;
    }
    p {
      margin-bottom: 24px;
    }
  }

  .health-tool-container {
    background-color: ${theme.colors.neutral50};
    ${MediaQueries.mbDown} {
      padding: 0;
    }
  }

  /* iframe {
    width: 100%;
    max-width: 100%;
  } */

  ${MediaQueries.mbUp} {
    .super-content-container {
      max-width: 768px;
      text-align: justify;
    }
    .health-tool-container {
      padding: 24px;
      max-width: 768px;
    }
  }

  .article-bottom-ad {
    ${MediaQueries.mbDown} {
      margin-bottom: var(--mobile-bottom-height);
      @supports (margin-bottom: env(safe-area-inset-bottom)) {
        margin-bottom: calc(
          env(safe-area-inset-bottom) + var(--mobile-bottom-height)
        );
      }
    }
  }
`

export const StyledSuperContentWrapper = styled.div<{ locale: LOCALE }>`
  overflow: visible;
  position: relative;
  min-height: 100vh;
  .banner {
    background-color: ${theme.colors.gray100};
  }

  #div-gpt-ad-home-top,
  #div-gpt-ad-home-sidebar1,
  #div-gpt-ad-home-sidebar2 {
    div {
      display: flex;
      overflow: hidden;
      max-width: 100%;
      justify-content: center;
    }
  }
  margin-bottom: 80px;

  .html-div {
    color: ${theme.colors.gray800};
    &[data-size='small'] {
      font-size: 16px;
      ${MediaQueries.mbUp} {
        font-size: 18px;
      }
    }
    &[data-size='medium'] {
      font-size: 19px;
      ${MediaQueries.mbUp} {
        font-size: 22px;
      }
    }
    &[data-size='large'] {
      font-size: 24px;
      ${MediaQueries.mbUp} {
        font-size: 27px;
      }
    }

    margin: 32px 0px;
    font-size: 18px;
    font-weight: normal;
    letter-spacing: -0.2px;
    line-height: 32px;

    ${MediaQueries.mbDown} {
      font-weight: normal;
      font-size: 16px;
      line-height: 28px;
    }
    p {
      margin-bottom: 24px;
    }
  }

  .health-tool-container {
    background-color: ${theme.colors.neutral50};
    ${MediaQueries.mbDown} {
      padding: 0;
    }
  }

  /* iframe {
    width: 100%;
    max-width: 100%;
  } */

  ${MediaQueries.mbUp} {
    .super-content-container {
      max-width: 768px;
      text-align: justify;
    }
    .health-tool-container {
      padding: 24px;
      max-width: 768px;
    }
    .health-concern-container {
      max-width: 768px;
    }
  }
`

export const StyledGeneralSectionContainer = styled.div`
  position: relative;
  overflow: visible;
  width: 100%;
  background-color: ${theme.colors.white};

  .trending-tab {
    position: sticky;
    z-index: 2;
    top: 0;
    width: 100%;

    border-bottom: none;
    background-color: ${theme.colors.white};

    & > ul {
      width: 100%;
    }

    & > ul > li > div > p {
      ${MediaQueries.mbUp} {
        font-size: ${theme.sizes.fsHeading6};
      }
    }

    ${MediaQueries.mbUp} {
      padding: 25px 0 8px;
    }

    ${MediaQueries.mbDown} {
      padding: 4px 0 0;
    }

    & > div {
      ${MediaQueries.mbUp} {
        padding: 0 16px;
      }
    }
  }

  &[data-is-top-bar-appears='true'] {
    .trending-tab {
      top: 64px;
      transition: top 0.5s;
    }
  }

  &[data-is-top-bar-appears='false'] {
    .trending-tab {
      top: 0;
      transition: top 0.5s;
    }
  }
`

export const StyledToolsCard = styled.div`
  display: flex;
  min-width: 100%;
  max-width: 400px;
  height: 100%;
  flex-direction: column;
  padding: 0 24px;
  border-radius: ${theme.borderRadius};

  filter: drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)),
    drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.06)),
    drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.04));
`
export const StyledActionBarWrapper = styled.div`
  position: absolute;
  z-index: 10;
  top: 80px;
  left: 50%;
  overflow: visible;
  width: 0;
  height: 100%;

  ${MediaQueries.mbUp} {
    .action-bar {
      top: min(6rem + 16px, 100vh / 4 + 16px);
      margin-left: -460px;
    }
  }
`

export const StyledLandingPageBanner = styled(LandingPageBanner)``
